package com.castly.shared.dto

import kotlinx.serialization.Serializable

@Serializable
data class OnixExportRequest(
    val audiobookIds: List<String>? = null,
    val authorId: Int? = null,
    val readerId: Int? = null,
    val search: String? = null
)
